<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Status</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Status List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Type</th>
                      <th scope="col">Description</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let status of statusData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                      }  ;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{status.name}}</th>
                      <th scope="col">{{status.type}}</th>
                      <th scope="col">{{status.description}}</th>
                      <th scope="col">
                        <svg xmlns="http://www.w3.org/2000/svg"   width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getStatusMasterById(status.statusInfoId)" data-toggle="modal" data-target="#exampleModalView"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
                    </th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="statusData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Status List</p>
                  </div>
                  <div class="add-block">
                      <div class="search">
                          <form autocomplete="off" >
                              <input type="text" placeholder="search">
                          </form>
                          <i class="bi bi-search" ></i>
                      </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 30%;">Name</th>
                        <th style="width: 20%;">Type</th>
                        <th style="width: 30%;">Description</th>
                        <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let status of statusData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                      }  ;let i = index">
      
                      <p style="width: 30%;">{{status.name}}</p>
                      <p style="width: 20%;">{{status.type}}</p>
                      <p style="width: 30%;">{{status.Description}}</p>
                      <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                          <!-- <i (click)="getPrivilegeByID(status.screenGroupId)" data-toggle="modal" data-target="#editModalView" class="bi bi-pencil-square"></i> -->
                          <i *ngIf="actionControls.isView" (click)="getStatusMasterById(status.statusInfoId)" data-toggle="modal" data-target="#exampleModalView" class="bi bi-eye-fill"></i>
                          <!-- <i (click)="del(privilege.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i> -->
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && statusData.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
  
        </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Status
            <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
    
          <div [formGroup]="form">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Name</label>
                          <input formControlName="name" type="text" class="form-control">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                        <label>Status Type</label>
                        <select name="" id="" formControlName="type" class="form-control">
                          <option value="" disabled selected hidden>---select type---</option>
                          <option value="{{status}}" *ngFor="let status of statusTypes">{{status}}</option>
                        </select>
                      </div>
                    </div>
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
              </div>
          </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" id="submit" (click)="addStatus()" class="btn btn-primary">Add Status</button>
        </div>
      </div>
    </div>
    </div>
  </div>  
 
<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Status Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let status of singleStatusMaster">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name</label>
                <input type="text" value="{{status.name}}" class="form-control">
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Status Type</label>
                <!-- <select name="" id="" class="form-control">
                  <option value="" disabled selected hidden>---select type---</option>
                  <option value="{{status}}" *ngFor="let status of statusTypes">{{status}}</option>
                </select> -->
                <input type="text" value="{{status.type}}" class="form-control">

              </div>
            </div>
          
            <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" value="{{status.description}}" name="" id="" cols="30" rows="10"></textarea>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
